import { render } from "./TermsModal.vue?vue&type=template&id=484fbbb9&lang=html"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dlin\\Desktop\\work\\webportal-lms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__